<template>
  <button
    type="submit"
    class="button"
    :class="{ ...styleSize, ...styleDisabled }"
    @click="exec()">
    {{ title }}
  </button>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    },

    size: {
      type: String
    },

    action: {
      required: true,
      type: Function
    },

    disabled: {
      type: Boolean
    }
  },

  computed: {
    styleSize: function () {
      if (this.size === 'full') {
        return { full: true }
      }
      return { default: true }
    },

    styleDisabled: function () {
      if (this.disabled) {
        return { disabled: true }
      }
      return {}
    }
  },

  methods: {
    exec: function () {
      if (this.disabled) {
        return
      }
      this.action()
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @include input-reset-design;
  height: 50px;
  border-radius: 4px;
  background: white;
  color: #3498db;
  font-weight: bold;
  font-size: 1.4em;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
}

.default {
  width: 80%;
}

.full {
  width: 100%;
}

.disabled {
  background: $silver;
  color: $cloud;
  &:hover {
    cursor: default;
  }
}
</style>
